import React from "react";
import Logo from "../../assets/logo.png";
import ImgInstituicao from "../../assets/BannerANU_ispa.jpg";
import ImgInternacional from "../../assets/BannerInsternacional.jpg";
import ImgPrograma from "../../assets/QU_ispa.jpg";
import ImgCientifica from "../../assets/JorBanner.jpg";
import ImgComunicacao from "../../assets/img2.jpg";
import "./Header.css";
import TopNav from "./TopNav";

// Hook para verificar a rota atual
function useCurrentPath() {
  const [currentPath, setCurrentPath] = React.useState("/");
  
  React.useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);
  
  return currentPath;
}

// Hook para scroll
function useScrolled(threshold = 20) {
  const [isScrolled, setIsScrolled] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return isScrolled;
}

// Hook para menu mobile
function useMobileMenu() {
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);
  const toggle = () => setIsOpen((v) => !v);
  const close = () => setIsOpen(false);
  return { isOpen, toggle, close };
}

// Hook para dropdowns
function useDropdown() {
  const [active, setActive] = React.useState(null);
  const toggle = (id) => setActive((curr) => (curr === id ? null : id));
  const close = () => setActive(null);
  return { active, toggle, close };
}

// Navegação com grupos
const navigationItems = [
  {
    id: 'home',
    label: 'Home',
    href: '/',
    type: 'link',
  },
  {
    id: 'instituicao',
    label: 'A Instituição',
    type: 'dropdown',
    image: ImgInstituicao,
    imageAlt: 'A Instituição',
    groups: [
      {
        title: 'Sobre Nós',
        links: [
          { href: '/instituicao', label: 'Apresentação' },
          { href: '/instituicao/palavra-do-presidente', label: 'Palavra do Presidente' },
          { href: '/instituicao/organigrama', label: 'Organigrama' },
          { href: '/instituicao/Legalidade', label: 'Legalidade' },
          { href: '/instituicao/decretos', label: 'Decretos' },
        ]
      },
      {
        title: 'Outros',
        links: [
          { href: '/instituicao/missao-visao-valores', label: 'Missão, Visão e Valores' },
          { href: '/instituicao/apoio-social', label: 'Ação Social' },
          { href: '/instituicao/perguntas-frequentes', label: 'Perguntas Frequentes' },
          { href: '/instituicao/regulamentos', label: 'Regulamento Interno' }
        ]
      }
    ]
  },
  {
    id: 'internacional',
    label: 'Internacional',
    type: 'dropdown',
    image: ImgInternacional,
    imageAlt: 'Internacional',
    groups: [
      {
        title: 'Estudar Conosco',
        links: [
          { href: '/internacional/porque-ispa', label: 'Porque Ispatlantida?' },
          { href: '/internacional/estudante', label: 'Estudante Internacional' },
          { href: '/internacional/alojamento', label: 'Alojamento' },
        ]
      }
    ]
  },
  {
    id: 'programa',
    label: 'Programa',
    type: 'dropdown',
    image: ImgPrograma,
    imageAlt: 'Programa',
    groups: [
      {
        title: 'Ensino',
        links: [
          { href: '/programas/licenciatura', label: 'Licenciatura' },
          { href: '/programas/unidade-organica', label: 'Unidade Orgânica' }
        ]
      }
    ]
  },
  {
    id: 'cientifica',
    label: 'Área Científica',
    type: 'dropdown',
    image: ImgCientifica,
    imageAlt: 'Área Científica',
    groups: [
      {
        title: 'Investigação e Extensão',
        links: [
          { href: '/investigacao/jornada-cientifica', label: 'Investigação' },
          { href: '/investigacao/Biblioteca-virtual', label: 'Biblioteca Virtual' }
        ]
      }
    ]
  },
  {
    id: 'comunicacao',
    label: 'Comunicação',
    type: 'dropdown',
    image: ImgComunicacao,
    imageAlt: 'Comunicação',
    groups: [
      {
        title: 'Atualizações',
        links: [
          { href: '/comunicacao/eventos', label: 'Eventos' },
          { href: '/comunicacao/noticias', label: 'Notícias' }
        ]
      }
    ]
  }
];

// Função para contar o total de links em um dropdown
const countTotalLinks = (item) => {
  return item.groups.reduce((total, group) => total + group.links.length, 0);
};

// Componente para dropdown com colunas
function DropdownMenu({ item, isOpen, onToggle, isMobile, isActive }) {
  const totalLinks = countTotalLinks(item);
  const hasManyLinks = totalLinks > 8; // Define o limite para mostrar barra de navegação
  
  return (
    <li className="nav__item">
      <button
        type="button"
        className={`nav__link ${isActive ? 'nav__link--active' : ''}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
        onClick={onToggle}
        onKeyDown={e => {
          if (["Enter", " "].includes(e.key)) {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        {item.label}
      </button>
      <div className={`mega-menu ${isMobile ? 'mega-menu--mobile' : ''} ${isOpen ? 'mega-menu--open' : ''} ${hasManyLinks && isMobile ? 'mega-menu--scrollable' : ''}`} role="menu" aria-label={`Menu ${item.label}`}>
        <div className="mega-menu__content">
          {!isMobile && item.image && (
            <div className="mega-menu__image">
              <img src={item.image} alt={item.imageAlt} loading="lazy" />
            </div>
          )}
          <div className="mega-menu__links" role="none">
            {item.groups?.map((group, groupIdx) => (
              <div key={groupIdx}>
                <div className="mega-menu__group-title">{group.title}</div>
                {group.links.map((link, linkIdx) => (
                  <a
                    key={linkIdx}
                    href={link.href}
                    className="mega-menu__link"
                    role="menuitem"
                    {...(link.external && {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      'aria-label': `${link.label} (abre em nova aba)`
                    })}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </li>
  );
}

// Componente para item simples
function NavLink({ item, isActive }) {
  return (
    <li className="nav__item">
      <a 
        href={item.href} 
        className={`nav__link ${isActive ? 'nav__link--active' : ''}`} 
        aria-label={item.label}
      >
        {item.label}
      </a>
    </li>
  );
}

function AppNavbar() {
  const isScrolled = useScrolled();
  const mobileMenu = useMobileMenu();
  const dropdown = useDropdown();
  const currentPath = useCurrentPath();

  // Função para verificar se um item está ativo
  const isItemActive = (item) => {
    if (item.type === 'link') {
      return item.href === currentPath;
    } else if (item.type === 'dropdown') {
      // Verifica se algum link dentro do dropdown corresponde ao caminho atual
      return item.groups.some(group => 
        group.links.some(link => link.href === currentPath)
      );
    }
    return false;
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      dropdown.close();
      mobileMenu.close();
    }
  };

  return (
    <>
      <header className={`header ${isScrolled ? 'header--scrolled' : ''}`} role="banner">
        <TopNav />
        <div className="header__container">
          <a href="/" className="header__brand" aria-label="Página inicial - ISPA Atlântida">
            <img src={Logo} alt="Logo ISPA Atlântida" className="header__logo" loading="eager" />
            <span className="header__title">Ispatlântida</span>
          </a>
          <button
            type="button"
            className={`mobile-toggle ${mobileMenu.isOpen ? 'mobile-toggle--active' : ''}`}
            aria-expanded={mobileMenu.isOpen}
            aria-controls="main-navigation"
            aria-label={mobileMenu.isOpen ? 'Fechar menu principal' : 'Abrir menu principal'}
            onClick={mobileMenu.toggle}
            onKeyDown={handleKeyDown}
          >
            <span className="mobile-toggle__line"></span>
            <span className="mobile-toggle__line"></span>
            <span className="mobile-toggle__line"></span>
          </button>
          <nav className={`nav ${mobileMenu.isOpen ? 'nav--open' : ''}`} id="main-navigation" role="navigation" aria-label="Menu principal">
            {navigationItems.map(item =>
              item.type === "dropdown" ? (
                <DropdownMenu
                  key={item.id}
                  item={item}
                  isOpen={dropdown.active === item.id}
                  onToggle={() => dropdown.toggle(item.id)}
                  isMobile={mobileMenu.isOpen}
                  isActive={isItemActive(item)}
                />
              ) : (
                <NavLink 
                  key={item.id} 
                  item={item} 
                  isActive={isItemActive(item)}
                />
              )
            )}
          </nav>
        </div>
      </header>
    </>
  );
}

export default AppNavbar;